import React from 'react';
import Checkbox from '@/v2/components/Checkbox/Checkbox';
import SelectableCard from '@/v2/components/Cards/SelectableCard/SelectableCard';

type CheckboxCardProps = {
  title: string;
  subtitle: string;
  selected: boolean;
  onSelect: () => void;
  disabled: boolean;
  children: React.ReactNode;
  variant?: 'vertical' | 'horizontal';
  size?: 'default' | 'compact';
  ariaLabel?: string;
  testId?: string;
};

export default function CheckboxCard({
  children,
  ...props
}: CheckboxCardProps) {
  return (
    <SelectableCard
      addonBefore={
        <Checkbox
          checked={props.selected}
          disabled={props.disabled}
          ariaHidden
        />
      }
      ariaRole="checkbox"
      {...props}
    >
      {children}
    </SelectableCard>
  );
}

CheckboxCard.Skeleton = SelectableCard.Skeleton;
